export type Translate = (key: string, values?: Record<string, string | number>) => string

export function matchQuality(score: number, t: Translate) {
  return t(
    score >= 6 ? 'matchQualityStrong' : score >= 3 ? 'matchQualityGood' : 'matchQualityPartial',
  )
}

export function matchActivity(value: string | null | undefined, t: Translate, now = Date.now()) {
  const timestamp = value ? Date.parse(value) : Number.NaN
  if (!Number.isFinite(timestamp)) return t('activeRecently')
  const days = Math.max(0, Math.floor((now - timestamp) / 86400000))
  return days === 0 ? t('activeToday') : t('activeDaysAgo', { count: Math.min(days, 99) })
}
